import * as React from 'react';
import { Box, Text, Toggle } from '@openfin/ui-library';

import { AppLogo } from '../AppLogo/AppLogo';

import styled from 'styled-components';

interface Props {
  toggleId: string;
  title: string;
  state: boolean;
  subToggle?: boolean;
  showLogo?: boolean;
  inset?: boolean;
  iconUrl?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SettingsToggle = ({
  title,
  state,
  showLogo = false,
  subToggle = false,
  iconUrl,
  onChange,
  toggleId,
}: Props): JSX.Element => {
  return (
    <Container subToggle={subToggle}>
      {showLogo && <AppLogo size="xlarge" src={iconUrl ?? ''} alt={title} />}
      <Title as="label" htmlFor={toggleId} size={subToggle ? 'base' : 'large'}>
        {title}
      </Title>
      <Toggle id={toggleId} checked={state} onChange={onChange} />
    </Container>
  );
};

const Container = styled(Box)<{ subToggle?: boolean }>`
  align-items: center;
  margin-bottom: 1em;
  width: 100%;

  &:last-child {
    margin-bottom: ${({ subToggle }) => (subToggle ? 0 : undefined)};
  }
`;

const Title = styled(Text)<{ htmlFor: string }>`
  font-size: ${({ theme }) => theme.fontSize.large};
  margin-right: auto;
  max-width: 205px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: break-word;
`;
